import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08a176c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sub-label" }
const _hoisted_2 = { class: "sub-label" }

import { IonIcon } from "@ionic/vue";
import { addOutline, closeOutline } from "ionicons/icons";
import { ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePropertyButton',
  props: {
  organisationPrefix: {
    type: String,
    default: "",
  },
  canCreateSurvey: {
    type: Boolean,
    default: false,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
},
  emits: ["createSurvey", "createObject", "extended"],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();




const extended = ref(false);
const mainIcon = ref(addOutline);

const toggleExtended = () => {
    extended.value = !extended.value;
    if( extended.value) {
        mainIcon.value = closeOutline;        
    } else {
        mainIcon.value = addOutline;
    }
    emit('extended', extended.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col items-stretch absolute right-3 z-10", {'bottom-3': !__props.isMobile, 'mobile-button': __props.isMobile && !extended.value, 'mobile-button-extended': __props.isMobile && extended.value}])
  }, [
    _withDirectives(_createElementVNode("div", {
      class: "flex flex-row justify-end sub-button mb-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createSurvey')))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)(`${__props.organisationPrefix}toolbar.mobile.surveyDetail`)), 1),
      _createVNode(_unref(IonIcon), {
        slot: "icon-only",
        icon: _unref(addOutline),
        class: "sub-icon"
      }, null, 8, ["icon"])
    ], 512), [
      [_vShow, extended.value && __props.canCreateSurvey]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "flex flex-row justify-end sub-button mb-2",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('createObject')))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(`${__props.organisationPrefix}toolbar.mobile.objectDetail`)), 1),
      _createVNode(_unref(IonIcon), {
        slot: "icon-only",
        icon: _unref(addOutline),
        class: "sub-icon"
      }, null, 8, ["icon"])
    ], 512), [
      [_vShow, extended.value]
    ]),
    _createVNode(_unref(IonIcon), {
      slot: "icon-only",
      class: _normalizeClass(["cpb self-end", __props.isMobile ? 'cpb-size-mobile' : 'cpb-size']),
      icon: mainIcon.value,
      onClick: toggleExtended
    }, null, 8, ["class", "icon"])
  ], 2))
}
}

})